module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/beauty-desktop@2x-27e48b767f589329974cc292d80dfc7a.jpg";